module.exports = __webpack_public_path__ + "static/img/fish26.fd3da5a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/jiejifish/fish26.png
// module id = gQca
// module chunks = 0